const states = {
  genai_intent_details: {
    //------------- GenAi Intents ---------------
    intents: [], //gi => genai intent
    gi_loading: false,
    gi_load_error: false,
    gi_search_key: "",
    gi_has_more: false,
    gi_pushing_id: null,
  },
}

export default states
